<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useUpdateRoute } from '@/functions'
  import { useBranchList } from '@/models/branch'

  const props = defineProps<{
    label?: string,
    onlyStores?: boolean,
    required?: boolean,
    queryKey?: string,
  }>()

  const route = useRoute()
  const { updateRoute } = useUpdateRoute()

  const { branches, loading, getData } = useBranchList()
  getData({ search: undefined })

  const selectedBranch = computed({
    set: (branch?: string) => updateRoute({ [props.queryKey ?? 'branch']: branch }),
    get: () => route.query[props.queryKey ?? 'branch'] as string | undefined,
  })

  const filteredBranches = computed(() => {
    if (props.onlyStores) {
      return branches.value.filter(branch => branch.facility_type === 'store')
    }

    return branches.value
  })
</script>

<template>
  <app-select
    v-model="selectedBranch"
    :label="label ?? 'Cabang'"
    :required="required"
    :loading="loading">
    <option :value="undefined">
      <template v-if="required">
        - Pilih Cabang -
      </template>
      <template v-else>
        Semua
      </template>
    </option>
    <option
      v-for="branch in filteredBranches"
      :key="branch.id"
      :value="branch.id">
      {{ branch.code }}
    </option>
  </app-select>
</template>
